import { CustomIconsProps } from './types';

export function CampanhasIcon({
  size = 24,
  color = '#2B52DD',
}: CustomIconsProps) {
  return (
    <svg
      width={size}
      height={size}
      viewBox="0 0 24 24"
      fill="none"
      xmlns="http://www.w3.org/2000/svg"
    >
      <g clipPath="url(#clip0_101_230)">
        <path
          d="M18.7786 8.98441L17.8146 4.02474C17.7724 3.80778 17.6458 3.61647 17.4625 3.49288C17.2793 3.36929 17.0545 3.32355 16.8375 3.36572L16.0195 3.52473C14.7153 5.45827 11.8501 6.95583 10.0498 7.7523L11.763 16.5657C13.7305 16.6298 16.9481 16.9449 18.8817 18.2491L19.6997 18.0901C19.9166 18.048 20.1079 17.9213 20.2315 17.7381C20.3551 17.5549 20.4009 17.3301 20.3587 17.1131L19.3946 12.1534C19.7286 11.9947 20.0003 11.7294 20.167 11.3993C20.3337 11.0692 20.3858 10.6931 20.3153 10.3301C20.2447 9.9671 20.0554 9.63789 19.7773 9.39427C19.4991 9.15065 19.1478 9.00646 18.7786 8.98441ZM5.20323 9.02292C4.76932 9.10727 4.38669 9.36052 4.13951 9.72698C3.89233 10.0934 3.80085 10.5431 3.8852 10.977L4.83924 15.8851C4.92359 16.319 5.17684 16.7017 5.5433 16.9488C5.90976 17.196 6.3594 17.2875 6.7933 17.2032L7.61133 17.0441L9.22439 20.9753L10.8604 20.6572L8.47532 8.38689L5.20323 9.02292Z"
          fill={color}
        />
      </g>
      <defs>
        <clipPath id="clip0_101_230">
          <rect
            width="20"
            height="20"
            fill="white"
            transform="translate(0 4.0918) rotate(-11)"
          />
        </clipPath>
      </defs>
    </svg>
  );
}
